import React from 'react';
import { useTheme } from '../../G&CSCM/Core/useTheme';

interface buttonModuleProps {
    parametre?: string;
    label?: string;
    text?: string;
}

const buttonModule: React.FC<buttonModuleProps> = (props) => {
    useTheme();

    const moduleName = 'buttonModule';
    
    // Les paramètres sont maintenant automatiquement injectés via les props
    const params = props;

    return (
        <div className={'BtnModule-Div'} style={{
            padding: '20px',
            border: '2px solid var(--primary-color)',
            borderRadius: '8px',
            backgroundColor: 'var(--background-color)',
            color: 'var(--text-color)',
            fontFamily: 'var(--font-family)'
        }}>
            <h3 style={{ color: 'var(--primary-color)', margin: '0 0 16px 0' }}>
                {moduleName} Module
            </h3>
            
            <div style={{ marginBottom: '16px' }}>
                <p style={{ margin: '0 0 8px 0', fontWeight: 'bold' }}>Paramètres du composant (mis à jour en temps réel) :</p>
                <pre style={{ 
                    backgroundColor: 'rgba(0,0,0,0.1)', 
                    padding: '8px', 
                    borderRadius: '4px',
                    fontSize: '12px',
                    margin: 0
                }}>
                    {JSON.stringify(params, null, 2)}
                </pre>
            </div>

            <div style={{ marginBottom: '16px' }}>
                <p style={{ margin: '0 0 8px 0', fontWeight: 'bold' }}>Couleurs du thème :</p>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    <div style={{ 
                        padding: '4px 8px', 
                        backgroundColor: 'var(--primary-color)', 
                        color: 'white',
                        borderRadius: '4px',
                        fontSize: '12px'
                    }}>
                        Primaire
                    </div>
                    <div style={{ 
                        padding: '4px 8px', 
                        backgroundColor: 'var(--secondary-color)', 
                        color: 'white',
                        borderRadius: '4px',
                        fontSize: '12px'
                    }}>
                        Secondaire
                    </div>
                    <div style={{ 
                        padding: '4px 8px', 
                        backgroundColor: 'var(--accentuated-color)', 
                        color: 'white',
                        borderRadius: '4px',
                        fontSize: '12px'
                    }}>
                        Accent
                    </div>
                </div>
            </div>

            <div>
                <p style={{ margin: '0 0 8px 0', fontWeight: 'bold' }}>Test de mise à jour en temps réel :</p>
                <p style={{ margin: 0, fontSize: '14px' }}>
                    Modifiez les paramètres "Label" et "Texte" dans l'éditeur de configuration 
                    pour voir les changements se refléter immédiatement ici !
                </p>
            </div>
        </div>
    );
};

export default buttonModule;